import { useCallback, useRef, useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Botao } from '../../components/Botao';
import { CorpoDaPagina } from '../../components/CorpoDaPagina';
import { Icone } from '../../components/Icone';
import { Input } from '../../components/Input';
import { Seletor } from '../../components/Seletor';
import { Tabela } from '../../components/Tabela';
import { ContextoUsuario } from '../../contextos/usuario/ProvedorUsuario';
import { InstituicaoStore } from '../../stores/InstituicaoStore';
import { MunicipioStore } from '../../stores/MunicipioStore';
import { SolicitacaoStore } from '../../stores/SolicitacaoStore';
import { Formulario, ConteinerCampo, ConteinerBotoes } from './styles';

function Solicitacao() {
  const [filtros, atribuirFiltros] = useState({});
  const [instituicoes, atribuirInstituicoes] = useState([]);
  const [instituicoesTotal, atribuirInstituicoesTotal] = useState([]);
  const [municipios, atribuirMunicipios] = useState([]);
  const [solicitacaoParametros, atribuirSolicitacaoParametros] = useState({
    pagina: 1,
    registroPorPagina: 30,
    ordenarDecrescente: false,
  });
  const [solicitacoes, atribuirSolicitacoes] = useState([]);
  const [totalPaginas, atribuirTotalPaginas] = useState(0);
  const [totalRegistro, atribuirTotalRegistro] = useState(0);

  const formulario = useRef(null);

  const historico = useHistory();

  const aoSubmeterFormulario = useCallback((data) => {
    atribuirFiltros(data);
  }, []);

  const { usuario } = useContext(ContextoUsuario);

  const redirecionar = (item, link) => {
    historico.push(item ? `${link}${item.protocolo}` : link);
  };

  const acao = [
    {
      texto: '',
      icone: 'FaEye',
      cor: 'info',
      aoClicar: redirecionar,
      redirecionar: '/solicitacao/visualizar/',
      retornarObjeto: true,
      tooltip: 'Visualizar',
    },
    {
      texto: '',
      icone: 'FaPen',
      cor: 'warning',
      aoClicar: redirecionar,
      redirecionar: '/solicitacao/editar/',
      retornarObjeto: true,
      valorDependencia: ['REPROVADO'],
      tooltip: 'Editar',
    },
  ];

  const colunas = [
    {
      nome: 'Aluno',
      propriedade: 'nomeCompleto',
      ordenavel: true,
      largura: '30%',
      filtrado: true,
    },
    {
      nome: 'Instituição',
      propriedade: 'nomeInstituicaoDeEnsino',
      ordenavel: true,
      largura: '30%',
      filtrado: true,
    },
    {
      nome: 'Data Solicitação',
      propriedade: 'dataSolicitacao',
      ordenavel: true,
      largura: '15%',
      filtrado: true,
      data: true,
    },
    {
      nome: 'Situação',
      propriedade: 'status',
      ordenavel: true,
      largura: '10%',
      filtrado: true,
    },
  ];

  const acoesTabela = (
    <Botao
      cor='success'
      texto='Nova solicitação'
      aoClicar={() => redirecionar(undefined, '/solicitacao/nova')}
    >
      <Icone nome='FaPlus' tamanho={16} />
    </Botao>
  );

  const limparFiltros = () => {
    formulario.current.reset();
    atribuirFiltros({});
  };

  const mudarMunicipio = (value) => {
    const InstituicoesFiltradas = [];
    instituicoesTotal.forEach((item) => {
      (item.cidade == value || !value) && InstituicoesFiltradas.push(item.nome);
    });

    atribuirInstituicoes([
      { label: 'Todas', value: '' },
      ...InstituicoesFiltradas.map((item) => ({
        label: item,
        value: item,
      })),
    ]);
  };

  const mudarPagina = (param) => {
    atribuirSolicitacaoParametros({ ...solicitacaoParametros, pagina: param });
  };

  useEffect(() => {
    const call = async () => {
      await InstituicaoStore.obterInstituicoes().then((response) => {
        if (response.status === 200) {
          if (response.data.length > 1) {
            atribuirInstituicoes([
              { label: 'Todas', value: '' },
              ...response.data.map((item) => ({
                label: item.nome,
                value: item.nome,
              })),
            ]);
          } else {
            atribuirInstituicoes([
              ...response.data.map((item) => ({
                label: item.nome,
                value: item.nome,
              })),
            ]);
          }
          atribuirInstituicoesTotal(response.data);
          const cidadesDistintas = [];
          response.data.forEach((escola) => {
            if (!cidadesDistintas.includes(escola.cidade)) {
              cidadesDistintas.push(escola.cidade);
            }
          });

          atribuirMunicipios([
            { label: 'Todas', value: '' },
            ...cidadesDistintas.map((item) => ({
              label: item,
              value: item,
            })),
          ]);
        } else if (response.status === 204) {
          toast.error('Não há instituições de ensino cadastradas');
        } else toast.error(response.data.mensagem);
      });
    };

    limparFiltros();

    const callMunicipios = async () => {
      await MunicipioStore.obterMunicipios({}).then((response) => {
        if (response.status === 200) {
          atribuirMunicipios([
            { label: 'Selecione', value: '' },
            ...response.data.map((item) => ({
              label: item.nome,
              value: item.nome,
            })),
          ]);
        } else if (response.status === 204) {
          toast.error('Não há municípios cadastrados');
        } else toast.error(response.data.mensagem);
      });
    };

    if (usuario.perfil !== 'Administrador') {
      call();
    } else {
      callMunicipios();
    }
  }, [usuario]);

  useEffect(() => {
    const call = async () => {
      await SolicitacaoStore.obterFiltrado({
        ...solicitacaoParametros,
        ...filtros,
      }).then((response) => {
        if (response.status === 200) {
          atribuirSolicitacoes(response.data.lista);
          atribuirTotalPaginas(response.data.totalDePaginas);
          atribuirTotalRegistro(response.data.totalDeRegistros);
        } else {
          toast.error(response.data.mensagem);
        }
      });
    };

    call();
  }, [filtros, solicitacaoParametros, usuario]);

  return (
    <CorpoDaPagina titulo='Solicitações'>
      <Formulario ref={formulario} onSubmit={aoSubmeterFormulario}>
        <ConteinerCampo>
          <Input
            titulo='Nome do aluno'
            nome='nomeCompleto'
            placeholder={'Informe o nome do aluno'}
          />
          <Input titulo='Período da solicitação - início' nome='dataInicio' tipo='date' />

          <Input titulo='Período da solicitação - fim' nome='dataFim' tipo='date' />

          {usuario.perfil === 'Administrador' ? (
            <Input
              titulo='Instituição de ensino'
              nome='nomeInstituicaoDeEnsino'
              placeholder={'Informe a instituição de ensino'}
            />
          ) : (
            <Seletor
              nome='nomeInstituicaoDeEnsino'
              titulo='Instituição de ensino'
              opcoes={instituicoes}
            />
          )}
        </ConteinerCampo>
        <ConteinerCampo>
          <Seletor
            nome='grauEscolaridade'
            titulo='Etapa ou modalidade de ensino'
            opcoes={[
              { label: 'Todos', value: '' },
              { label: 'EAD - Superior', value: 'EADSuperior' },
              { label: 'Presencial - Superior', value: 'Superior' },
              { label: 'Ensino Fundamental', value: 'Fundamental' },
              { label: 'Ensino Médio', value: 'Médio' },
              { label: 'Educação de Jovens Adultos', value: 'eja' },
              { label: 'Educação Profissional', value: 'Profissional' },
              { label: 'Educação Infantil', value: 'Infantil' },
            ]}
          />

          {usuario.perfil === 'Administrador' && (
            <Seletor
              nome='dependenciaAdministrativa'
              titulo='Dependência administrativa'
              opcoes={[
                { label: 'Todas', value: '' },
                { label: 'Federal', value: 'Federal' },
                { label: 'Privada', value: 'Privada' },
                { label: 'Municipal', value: 'Municipal' },
                { label: 'Estadual', value: 'Estadual' },
              ]}
            />
          )}
          <Seletor
            nome='status'
            titulo='Situação'
            opcoes={[
              { label: 'Todas', value: '' },
              { label: 'Em Análise', value: 'EM ANÁLISE' },
              { label: 'Reprovado', value: 'REPROVADO' },
              { label: 'Aprovado', value: 'APROVADO' },
            ]}
          />
          <Seletor
            nome='cidade'
            titulo='Município'
            aoAtribuirValor={mudarMunicipio}
            opcoes={municipios}
            desabilitado={municipios.length === 0}
          />
        </ConteinerCampo>
        <ConteinerBotoes>
          <Botao texto='Limpar filtros' cor='danger' outlined aoClicar={() => limparFiltros()} />
          <Botao texto='Filtrar' tipo='submit' />
        </ConteinerBotoes>
      </Formulario>
      <Tabela
        colunas={colunas}
        acoesDoRegistro={acao}
        dados={solicitacoes}
        acoesDaTabela={acoesTabela}
        aoMudarDePagina={mudarPagina}
        totalDePaginas={totalPaginas}
        totalDeRegistros={totalRegistro}
        registrosPorPagina={solicitacaoParametros.registroPorPagina}
        aoOrdenar={(column, desc) =>
          atribuirSolicitacaoParametros({
            ...solicitacaoParametros,
            ordenarPor: column,
            ordenarDecrescente: desc,
          })
        }
        ordenacaoDecresente={solicitacaoParametros.ordenarDecrescente}
        ordenarPor={solicitacaoParametros.ordenarPor}
      />
    </CorpoDaPagina>
  );
}

export default Solicitacao;
